<modal-panel title="Add ERP Adjustment (Simulation)" data-testid="add-erp-adjustment-dialog" (close)="cancel()">
  <div class="add-adjustment__fields" [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>ADX Invoice</mat-label>
      <mat-select formControlName="adxInvoiceId" (selectionChange)="onInvoiceChanged()" data-testid="add-adjustment-invoice">
        @for (invoice of invoices; track invoice.id) {
          <mat-option [value]="invoice.id">#{{ invoice.id }}{{ invoice.recordLocator ? ' - ' + invoice.recordLocator : '' }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Legal Entity</mat-label>
      <mat-select formControlName="legalEntityId" data-testid="add-adjustment-legal-entity">
        @for (entity of legalEntities; track entity.id) {
          <mat-option [value]="entity.id">{{ entity.dataAreaId }}{{ entity.name ? ' - ' + entity.name : '' }}</mat-option>
        }
      </mat-select>
      @if (selectedLegalEntity?.outboundQueue) {
        <mat-hint>Queue: {{ selectedLegalEntity?.outboundQueue }}</mat-hint>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Record Locator (PNR)</mat-label>
      <input matInput formControlName="pnr" [maxlength]="maxLength" data-testid="add-adjustment-pnr" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Adjustment Type</mat-label>
      <mat-select formControlName="adjustmentTypeId" data-testid="add-adjustment-type">
        @for (type of adjustmentTypes; track type.id) {
          <mat-option [value]="type.id">{{ type.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (isRefund) {
      <mat-form-field appearance="outline">
        <mat-label>ADX Bookings</mat-label>
        <mat-select formControlName="adxBookingIds" multiple (selectionChange)="onBookingsChanged()" data-testid="add-adjustment-bookings">
          @for (booking of bookings; track booking.id) {
            <mat-option [value]="booking.id">{{ bookingLabel(booking) }}</mat-option>
          }
        </mat-select>
        <mat-hint>One ERP line is created per selected booking.</mat-hint>
      </mat-form-field>
    }

    <mat-form-field appearance="outline">
      <mat-label>ERP Invoice No.</mat-label>
      <input matInput formControlName="rawText" [maxlength]="maxLength" data-testid="add-adjustment-raw-text" />
      <mat-hint>Drives ERP invoice / sales order / trailer.</mat-hint>
    </mat-form-field>
    @if (prefixedPreview) {
      <p class="add-adjustment__preview">
        ERP invoice / Sales order / Trailer: {{ invoicePreview }}
      </p>
    }

    <div formArrayName="lines" class="add-adjustment__lines">
      @for (line of lines.controls; track $index; let i = $index) {
        <fieldset class="add-adjustment__line" [formGroupName]="i" [attr.data-testid]="'add-adjustment-line-' + i">
          <legend>{{ isRefund ? 'Booking ' + bookingLabelById(line.controls['adxBookingId'].value) : 'Voucher line (GiftCard)' }}</legend>

          @if (isRefund) {
            <mat-form-field appearance="outline">
              <mat-label>Item Number</mat-label>
              <input matInput formControlName="itemNumber" [maxlength]="maxLength" />
            </mat-form-field>
          }

          <mat-form-field appearance="outline">
            <mat-label>Cost Price</mat-label>
            <input matInput type="number" min="0" step="0.01" formControlName="costPrice" />
            <mat-hint>Positive amount{{ isRefund ? '; stored negative for refunds.' : '.' }}</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Cost Currency</mat-label>
            <mat-select formControlName="costCurrency">
              @for (currency of currencies; track currency.id) {
                <mat-option [value]="currency.code">{{ currency.code }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Sales Price</mat-label>
            <input matInput type="number" min="0" step="0.01" formControlName="salesPrice" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Sales Currency</mat-label>
            <mat-select formControlName="salesCurrency">
              @for (currency of currencies; track currency.id) {
                <mat-option [value]="currency.code">{{ currency.code }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </fieldset>
      }
    </div>
  </div>

  <ng-container modalPanelFooter>
    <button mat-raised-button color="primary" type="submit" data-testid="add-adjustment-submit"
            (click)="submit()" [disabled]="saving || form.invalid">
      @if (saving) {
        <mat-spinner diameter="20"/>
      } @else {
        Create
      }
    </button>
    <button mat-button (click)="cancel()">Cancel</button>
  </ng-container>
</modal-panel>
